{
  "thought": {
    "smooth_tempo": {
      "term": "Smooth tempo",
      "line": "Smooth tempo: helps a hard or all-out swing."
    },
    "finish_the_swing": {
      "term": "Finish the swing",
      "line": "Finish the swing: helps into the wind or from the rough."
    },
    "small_target": {
      "term": "Small target",
      "line": "Small target: tighter on the line, a little looser for distance."
    },
    "stay_tall": {
      "term": "Stay tall",
      "line": "Stay tall: helps on a hill or in a fairway bunker."
    },
    "soft_hands": {
      "term": "Soft hands",
      "line": "Soft hands: helps a lob, a splash or a long explosion."
    },
    "land_on_a_spot": {
      "term": "Land it on a spot",
      "line": "Land it on a spot: helps a pitch or a bump and run."
    },
    "brush_the_grass": {
      "term": "Brush the grass",
      "line": "Brush the grass: helps from a tight, bare or wet lie."
    },
    "keep_turning": {
      "term": "Keep turning",
      "line": "Keep turning: helps when the nerves are up."
    },
    "head_still": {
      "term": "Head still",
      "line": "Head still: helps a short putt."
    },
    "smooth_stroke": {
      "term": "Smooth stroke",
      "line": "Smooth stroke: helps a long putt."
    },
    "roll_it_over_a_spot": {
      "term": "Roll it over a spot",
      "line": "Roll it over a spot: helps a putt that breaks a cup or more."
    },
    "listen_for_it": {
      "term": "Listen for it",
      "line": "Listen for it: helps when the nerves are up."
    }
  },
  "caddie_level": {
    "$note": "25 TON-036's row for the five caddie levels (code name caddie.level 1 to 5). Its table gives Stage 7, but the round report first shows the names in Stage 2 (TON-098's caddie line; decision record 0158), so by TON-036 the row ships with Stage 2. Each term is a level's name, written exactly as round:caddie.level.name.N writes it; the line is the row's plain explanation, word for word.",
    "term": {
      "1": "Trainee",
      "2": "Club caddie",
      "3": "County caddie",
      "4": "Tour caddie",
      "5": "Major caddie"
    },
    "line": "The five caddie levels, from 1 to 5. A higher level does more jobs."
  }
}
